import "zod/compile";
import { z } from "zod";
import { EXTENSION_TARGET_MODELS } from "./schemaDefinitions";
import { ExtensionValueSchema } from "./schemaExtensions";

const FieldId = z
  .string()
  .min(1)
  .max(255)
  .refine((id) => id === id.trim());
const Address = z.strictObject({
  targetModel: z.enum(EXTENSION_TARGET_MODELS),
  entityKey: z.string().min(1).max(1024),
  extensionId: z.uuid().transform((id) => id.toLowerCase()),
});
export const ExtensionValueWriteSchema = Address.extend({
  values: z
    .record(FieldId, ExtensionValueSchema)
    .refine(
      (values) =>
        Object.keys(values).length > 0 && Object.keys(values).length <= 1000,
      { message: "Select between 1 and 1000 fields" },
    ),
});
export const AgentExtensionValueReadSchema = Address.extend({
  fieldIds: z.array(FieldId).min(1).max(1000),
});
export const ExtensionValueWriteResultSchema = z.strictObject({
  status: z.enum(["changed", "unchanged"]),
  changedFieldIds: z.array(FieldId),
  changeId: z.uuid().nullable(),
});
export const ExtensionValueFieldIssueSchema = z.strictObject({
  fieldId: FieldId,
  code: z.enum([
    "unknown_field",
    "agent_write_disabled",
    "agent_read_disabled",
    "invalid_value",
    "required_value_missing",
  ]),
});
export const AgentExtensionValueReadResultSchema = z.strictObject({
  values: z.record(FieldId, ExtensionValueSchema),
  issues: z.array(ExtensionValueFieldIssueSchema),
});
export type AgentExtensionValueReadResult = z.infer<
  typeof AgentExtensionValueReadResultSchema
>;
export type ExtensionValueWrite = z.infer<typeof ExtensionValueWriteSchema>;
export type AgentExtensionValueRead = z.infer<
  typeof AgentExtensionValueReadSchema
>;
export type ExtensionValueWriteResult = z.infer<
  typeof ExtensionValueWriteResultSchema
>;
export type ExtensionValueFieldIssue = z.infer<
  typeof ExtensionValueFieldIssueSchema
>;
